import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { Auth } from '../services/auth/auth';

/*
 * Rotas cujo 401/403 não fala sobre a sessão do usuário: o login trata a própria credencial e o
 * /internal/auth/status é público — derrubar a sessão por causa dele seria falso positivo.
 * Habilitar/desabilitar ficam de fora desta lista de propósito: agora dependem do JWT, então um
 * 401/403 ali significa mesmo que a sessão não vale mais.
 */
const CAMINHOS_IGNORADOS = ['/auth/login', '/internal/auth/status'];

export const autenticacaoInterceptor: HttpInterceptorFn = (requisicao, proxima) => {
    const auth = inject(Auth);
    const router = inject(Router);

    const token = auth.getToken();
    const requisicaoFinal = token ? requisicao.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : requisicao;

    return proxima(requisicaoFinal).pipe(
        catchError((erro: unknown) => {
            if (deveEncerrarSessao(erro, requisicao.url)) {
                const returnUrl = router.url;
                auth.logout();
                router.navigate(['/login'], { queryParams: { returnUrl } });
            }

            return throwError(() => erro);
        })
    );
};

function deveEncerrarSessao(erro: unknown, url: string): boolean {
    if (CAMINHOS_IGNORADOS.some((caminho) => url.includes(caminho))) return false;
    if (!(erro instanceof HttpErrorResponse)) return false;

    return erro.status === 401 || erro.status === 403;
}
